// eslint-disable-next-line import/no-extraneous-dependencies
import { tns } from 'tiny-slider/src/tiny-slider';
import classify from '../../helpers/classify';

export const CAROUSEL_ID = 'cms-range-picker-carousel';
export const SLIDER = `${CAROUSEL_ID}__slider`;
export const TILE = 'cms-range-picker-tile';
export const CONTROLS_CONTAINER = `${CAROUSEL_ID}__controls-container`;
export const TILE_BUTTON = `${CAROUSEL_ID}__tile-button`;
export const PREV_NEXT_CONTAINER = `${CAROUSEL_ID}__prev-next-container`;
export const CENTRAL_TILE = 'central';

const initCarousel = (carousel: HTMLDivElement): void => {
  const sliderContainer = carousel.querySelector<HTMLDivElement>(classify(SLIDER));
  const prevNextContainer = carousel.querySelector<HTMLDivElement>(classify(PREV_NEXT_CONTAINER));
  const controlsContainer = carousel.querySelector<HTMLDivElement>(classify(CONTROLS_CONTAINER));
  const tiles = carousel.querySelectorAll<HTMLDivElement>(classify(TILE));

  const slider = tns({
    container: sliderContainer || '',
    center: true,
    loop: false,
    autoWidth: true,
    gutter: 16,
    mouseDrag: true,
    controlsContainer: prevNextContainer || '',
    navPosition: 'bottom',
    responsive: {
      768: {
        gutter: 32
      }
    }
  });

  if (!slider) {
    return;
  }

  tiles.forEach((tile, index) => {
    const tileButton = document.createElement('button');
    tileButton.classList.add(TILE_BUTTON);
    tileButton.textContent = tile.dataset.name || '';
    tileButton.dataset.index = `${index}`;
    tileButton.addEventListener('click', () => {
      slider.goTo(index);
    });
    controlsContainer?.appendChild(tileButton);

    tile.addEventListener('click', () => {
      slider.goTo(index);
      carousel.querySelector(classify(CENTRAL_TILE))?.classList.remove(CENTRAL_TILE);
    });
  });

  slider.events.on('transitionEnd', () => {
    const tileButtons = carousel.querySelectorAll<HTMLButtonElement>(classify(TILE_BUTTON));
    tileButtons.forEach((button) => {
      const buttonIndex = button.dataset.index || '';
      button.classList[+buttonIndex === slider.getInfo().index ? 'add' : 'remove']('active');
      tiles[slider.getInfo().index].classList.add(CENTRAL_TILE);
    });
  });
};

const findAllRangePickerCarousels = (): NodeListOf<HTMLDivElement> =>
  document.querySelectorAll<HTMLDivElement>(classify(CAROUSEL_ID));

type InitAllCarouselsProps = {
  disablePreview: boolean;
};

export function initAllRangePickerCarousels(
  { disablePreview }: InitAllCarouselsProps = { disablePreview: false }
): void {
  if (disablePreview) {
    return;
  }

  const allCarousels = findAllRangePickerCarousels();
  allCarousels.forEach((c) => {
    initCarousel(c);
  });
}
